export class ResultHelper
{
  public static formatResult(sets1: number, sets2: number, legs1: number, legs2: number, setOrLeg?: number, homeAway?: number): string
  {
    // console.log('formatResult, legs1: ' + legs1 + ', legs2: ' + legs2);
    let s = '';
    const hasSets = sets1 > 0 || sets2 > 0;
    // const inputLegsSingle = match.phase?.setInputTypeCd === DOMAIN_VALUE_CD_SET_INPUT_TYPE_LEGS_SINGLE;
    const inputLegsSingle = false;
    const short = false;

    if (hasSets && (!setOrLeg || setOrLeg === 1))
    {
      if (homeAway === 1)
        s = sets1 + '';
      else if (homeAway === 2)
        s = sets2 + '';
      else s = sets1 + '-' + sets2;
    }
    if ((legs1 > 0 || legs2 > 0) && (inputLegsSingle || !setOrLeg || setOrLeg === 2))
    {
      if (homeAway === 1)
        s += (hasSets ? '' : (legs1 + ''));
      else if (homeAway === 2)
        s += (hasSets ? '' : (legs2 + ''));
      else
      {
        if (!hasSets || !short)
          s += (s.length > 0 ? ' (' : '') + legs1 + '-' + legs2 + (s.length > 0 ? ')' : '');
      }
    }
    return s;
  }
}
